import { NEIGHBORS } from "../data/board-geometry";
import type { Direction, PlayerColor } from "../types/common";
import type { Board, CellContent } from "../types/game-state";

const ALL_DIRECTIONS: readonly Direction[] = ["N", "NE", "SE", "S", "SW", "NW"];

export function flipMarkers(board: Board, positions: readonly string[]): Board {
  if (positions.length === 0) return board;
  const updated: Record<string, CellContent> = { ...board };
  for (const pos of positions) {
    const cell = board[pos] ?? null;
    if (cell?.type === "MARKER") {
      updated[pos] = {
        type: "MARKER",
        player: cell.player === "WHITE" ? "BLACK" : "WHITE",
      };
    }
  }
  return updated;
}

export function getMarkersJumped(
  board: Board,
  from: string,
  to: string,
): readonly string[] {
  // Determine direction from → to
  for (const dir of ALL_DIRECTIONS) {
    let cur: string | undefined = NEIGHBORS[from]?.[dir];
    const path: string[] = [];
    while (cur !== undefined && cur !== to) {
      path.push(cur);
      cur = NEIGHBORS[cur]?.[dir];
    }
    if (cur === to) {
      // Only return positions that have markers
      return path.filter((p) => (board[p] ?? null)?.type === "MARKER");
    }
  }
  return [];
}

export function getPlayerRingPositions(
  board: Board,
  player: PlayerColor,
): readonly string[] {
  return Object.entries(board)
    .filter(([, cell]) => cell?.type === "RING" && cell.player === player)
    .map(([pos]) => pos);
}
